export const normalizePathValue = (path) => String(path || '').trim();

export const trimTrailingPathSeparators = (path) => {
  const pathValue = String(path || '');

  // A drive-relative path ("C:") does not mean the same thing as its root
  // ("C:\\"). Preserve exactly one separator for Windows and POSIX roots.
  if (/^[A-Za-z]:[\\/]+$/.test(pathValue)) {
    return `${pathValue.slice(0, 2)}${pathValue[2]}`;
  }
  if (/^[\\/]+$/.test(pathValue)) {
    return pathValue[0];
  }

  return pathValue.replace(/[\\/]+$/, '');
};

export const getPathFileName = (path, fallback = '') => {
  const fileName = String(path || '').split(/[\\/]/).pop();
  return fileName || fallback;
};

export const appendFileNameToFolderPath = (folderPath, fileName) => {
  const originalFolderPath = String(folderPath || '');
  const cleanFolderPath = trimTrailingPathSeparators(originalFolderPath);
  const separator = originalFolderPath.includes('\\') ? '\\' : '/';

  if (cleanFolderPath) {
    const separatorSuffix = /[\\/]$/.test(cleanFolderPath) ? '' : separator;
    return `${cleanFolderPath}${separatorSuffix}${fileName}`;
  }
  return originalFolderPath ? `${separator}${fileName}` : String(fileName || '');
};
